<template>
  <v-container>
    <h3 class="mb-4">Libri ordinati non ricevuti</h3>
    <v-row align="center" class="mb-2">
      <v-col cols="12" sm="6" md="2">
        <InputDataPicker
          v-model="filters.date_from"
          label="Data da"
          :clearable="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <InputDataPicker
          v-model="filters.date_to"
          label="Data a"
          :clearable="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <PropagandistSelect
          v-model="filters.propagandist_id"
          label="Propagandista"
          :clearable="true"
        />
      </v-col>
      <v-col cols="6" sm="3" md="1">
        <v-text-field
          v-model="filters.order_id"
          label="N. Ordine"
          clearable
          type="number"
        />
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <v-text-field
          v-model="filters.isbn"
          label="ISBN"
          clearable
        />
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-text-field
          v-model="filters.title"
          label="Titolo"
          clearable
        />
      </v-col>
      <v-col cols="12" sm="6" md="1" class="d-flex align-center justify-end">
        <v-btn color="primary" @click="downloadCsv" :loading="exporting">
          <v-icon left>cloud_download</v-icon>
          CSV
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :options.sync="pagination"
      :loading="loading"
      hide-default-footer
      class="elevation-1"
    >
      <template v-slot:item.order_id="{ item }">
        <router-link :to="{ name: 'campaign_report_booked_order', query: { order_id: item.order_id } }">
          #{{ item.order_id }}
        </router-link>
      </template>
      <template v-slot:item.mancanti="{ item }">
        <span :class="item.mancanti > 0 ? 'red--text font-weight-bold' : ''">
          {{ item.mancanti }}
        </span>
      </template>
      <template v-slot:item.order_date="{ item }">
        {{ formatDate(item.order_date) }}
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchData"
    />
  </v-container>
</template>
<script>
import { anomalyService } from '../../../utils/services/anomaly.service';
import InputDataPicker from '../../../components/shared/Inputs/InputDataPicker.vue';
import PropagandistSelect from '../../../components/shared/Vselects/PropagandistSelect.vue';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AnomalyOrdersMissing',
  components: {
    InputDataPicker,
    PropagandistSelect,
    Paginator,
  },
  data() {
    return {
      loading: false,
      exporting: false,
      items: [],
      totalItems: 0,
      pagination: { page: 1, itemsPerPage: 20 },
      filters: {
        date_from: null,
        date_to: null,
        propagandist_id: 0,
        order_id: null,
        isbn: null,
        title: null,
      },
      headers: [
        { text: 'Ordine', value: 'order_id' },
        { text: 'Propagandista', value: 'propagandista' },
        { text: 'Docente', value: 'docente' },
        { text: 'ISBN', value: 'isbn' },
        { text: 'Titolo', value: 'title' },
        { text: 'Ordinati', value: 'qty_ordered' },
        { text: 'Ricevuti', value: 'qty_received' },
        { text: 'Mancanti', value: 'mancanti' },
        { text: 'Data Ordine', value: 'order_date' },
      ],
    };
  },
  computed: {
    requestFilters() {
      return {
        date_from: this.filters.date_from,
        date_to: this.filters.date_to,
        propagandist_id: this.filters.propagandist_id,
        order_id: this.filters.order_id,
        isbn: this.filters.isbn,
        title: this.filters.title,
      };
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.pagination.page = 1;
        this.fetchData();
      },
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    formatDate(dateStr) {
      // Data grezza dal DB, in UTC
      return this.$options.filters.utcTime(dateStr, 'DD/MM/YYYY HH:mm');
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await anomalyService.getOrdersMissing({
          page: this.pagination.page,
          itemsPerPage: this.pagination.itemsPerPage,
          filters: this.requestFilters,
        });
        this.items = response.data.data;
        this.totalItems = response.data.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async downloadCsv() {
      this.exporting = true;
      try {
        const response = await anomalyService.exportOrdersMissing({
          filters: this.requestFilters,
        });
        const csv = response.data.csv;
        if (!csv) {
          alert('Nessun dato da esportare');
          return;
        }
        const blob = new Blob([csv], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'ordini_mancanti.txt';
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error(error);
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>
